/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Typewriter_LocationInputs */

const en_typewriter_location = /** @type {(inputs: Typewriter_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Based in Dhaka, Bangladesh`)
};

const ar_typewriter_location = /** @type {(inputs: Typewriter_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أقيم في دكا، بنغلاديش`)
};

const bn_typewriter_location = /** @type {(inputs: Typewriter_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ঢাকা, বাংলাদেশ`)
};

const de_typewriter_location = /** @type {(inputs: Typewriter_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitz in Dhaka, Bangladesch`)
};

const es_typewriter_location = /** @type {(inputs: Typewriter_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con sede en Dhaka, Bangladesh`)
};

const fr_typewriter_location = /** @type {(inputs: Typewriter_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basé à Dhaka, Bangladesh`)
};

const pt_typewriter_location = /** @type {(inputs: Typewriter_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseado em Dhaka, Bangladesh`)
};

const zh_typewriter_location = /** @type {(inputs: Typewriter_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总部位于孟加拉国达卡`)
};

const tr_typewriter_location = /** @type {(inputs: Typewriter_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkezi Dakka, Bangladeş'te`)
};

const ru_typewriter_location = /** @type {(inputs: Typewriter_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Базируется в Дакке, Бангладеш.`)
};

const pl_typewriter_location = /** @type {(inputs: Typewriter_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siedziba mieści się w Dhace w Bangladeszu`)
};

/**
* | output |
* | --- |
* | "Based in Dhaka, Bangladesh" |
*
* @param {Typewriter_LocationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const typewriter_location = /** @type {((inputs?: Typewriter_LocationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Typewriter_LocationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_typewriter_location(inputs)
	if (locale === "bn") return bn_typewriter_location(inputs)
	if (locale === "de") return de_typewriter_location(inputs)
	if (locale === "es") return es_typewriter_location(inputs)
	if (locale === "fr") return fr_typewriter_location(inputs)
	if (locale === "pt") return pt_typewriter_location(inputs)
	if (locale === "zh") return zh_typewriter_location(inputs)
	if (locale === "tr") return tr_typewriter_location(inputs)
	if (locale === "ru") return ru_typewriter_location(inputs)
	if (locale === "pl") return pl_typewriter_location(inputs)
	return en_typewriter_location(inputs)
});